import { BufferGeometry, BufferAttribute } from 'three';

interface GeometryBuffers {
  readonly positions: Float32Array;
  readonly normals: Float32Array;
  readonly colors: Float32Array;
  readonly facade: Float32Array;
  readonly meta: Float32Array;
  readonly exaggeration: Float32Array | undefined;
  readonly axisOffset: Float32Array | undefined;
  readonly painterOffset: Float32Array | undefined;
  readonly indices: Uint32Array;
}

/** Copy only authored vertices, so a later builder append cannot change an existing mesh. */
export function geometrySnapshot(
  buffers: GeometryBuffers,
  vertexCount: number,
  triangleCount: number
): BufferGeometry {
  const geometry = new BufferGeometry();
  geometry.setAttribute(
    'position',
    new BufferAttribute(buffers.positions.slice(0, vertexCount * 3), 3)
  );
  geometry.setAttribute(
    'normal',
    new BufferAttribute(buffers.normals.slice(0, vertexCount * 3), 3)
  );
  geometry.setAttribute('color', new BufferAttribute(buffers.colors.slice(0, vertexCount * 3), 3));
  geometry.setAttribute(
    'aFacade',
    new BufferAttribute(buffers.facade.slice(0, vertexCount * 4), 4)
  );
  geometry.setAttribute('aMeta', new BufferAttribute(buffers.meta.slice(0, vertexCount * 4), 4));
  if (buffers.exaggeration)
    geometry.setAttribute(
      'aExaggeration',
      new BufferAttribute(buffers.exaggeration.slice(0, vertexCount * 2), 2)
    );
  if (buffers.axisOffset)
    geometry.setAttribute(
      'aAxisOffset',
      new BufferAttribute(buffers.axisOffset.slice(0, vertexCount * 3), 3)
    );
  if (buffers.painterOffset)
    geometry.setAttribute(
      'aPainterOffset',
      new BufferAttribute(buffers.painterOffset.slice(0, vertexCount * 3), 3)
    );
  geometry.setIndex(new BufferAttribute(buffers.indices.slice(0, triangleCount * 3), 1));
  geometry.computeBoundingSphere();
  return geometry;
}
